module.exports = __webpack_public_path__ + "img/14@2x.8298fd2e.png";